import { inject, Injectable } from '@angular/core';
import {
  type MarkImportantNoticeAsReadMutation,
  type MarkImportantNoticeAsReadMutationVariables,
} from '@reconcept-platform/shared/types';
import { gql } from 'apollo-angular';
import { SharedGraphQlService } from '../../services/shared-graphql.service';

@Injectable({
  providedIn: 'root',
})
export class ImportantNoticeApi {
  private graphqlService = inject(SharedGraphQlService);

  markImportantNoticeAsRead(importantNoticeId: string) {
    return this.graphqlService.mutateV2<MarkImportantNoticeAsReadMutation, MarkImportantNoticeAsReadMutationVariables>({
      mutation: gql`
        mutation markImportantNoticeAsRead($input: MarkImportantNoticeAsReadInput!) {
          markImportantNoticeAsRead(input: $input) {
            errors {
              message
              path
            }
          }
        }
      `,
      variables: {
        input: {
          importantNoticeId,
        },
      },
    });
  }
}
